<template>
  <div>
    <h1>Other Info (Protected)</h1>

    <div v-if="!accessGranted">
      <p>Enter Password:</p>
      <input type="password" v-model="enteredPassword" />
      <br/><br/>
      <button   class="btn btn-success" @click="checkPassword">Submit</button>
      <p v-if="errorMessage" style="color: red;">{{ errorMessage }}</p>
    </div>

    <div  class="container my-5" v-else>
      <p>Access Granted</p>
      <p>This is the protected Business Plan information.</p>
    
         <div class="container py-4">
      <div class="card shadow-lg border-0 rounded-4">

          <!-- Main heading (center) -->
        <h2 class="text-success fw-bold mb-3 text-center">
          Business Plan – Academy Name
        </h2>

        <!-- Subheading (left) -->
        <h4 class="text-success fw-semibold mb-2">
          Executive Summary
        </h4>

        <!-- Smaller subheading under it -->
        <h5 class="text-success fw-semibold mb-3">
          Business Overview:
        </h5>
        <h5 class="text-success fw-semibold mb-3">
          Vision:
        </h5>
          <br/>
         <h4 class="text-success fw-semibold mb-2">
          Company Description
        </h4>
         <!-- Smaller subheading under it -->
        <h5 class="text-success fw-semibold mb-3">
          Mission Statement::
        </h5>
        <h5 class="text-success fw-semibold mb-3">
          Legal Structure:
        </h5>
         <h5 class="text-success fw-semibold mb-3">
          Founder and Director: 
        </h5>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enteredPassword: "",
      accessGranted: false,
      errorMessage: ""
    };
  },
  methods: {
    async checkPassword() {
      try {
        const res = await fetch("/api/check-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: this.enteredPassword })
        });

        const data = await res.json();
        if (data.access) {
          this.accessGranted = true;
          this.errorMessage = "";
        } else {
          this.errorMessage = "❌ Wrong password!";
        }
      } catch (err) {
        console.error("Error checking password", err);
        this.errorMessage = "Server error, try again.";
      }
    }
  }
};
</script>
